import {
    CORE_CREATE_SYNC_REQUEST,
    CORE_CREATE_SYNC_SUCCESS,

    CORE_EDIT_SYNC_REQUEST,
    CORE_EDIT_SYNC_SUCCESS,

    CORE_LOAD_SYNC_USER_REQUEST,
    CORE_LOAD_SYNC_USER_SUCCESS,

    CORE_LOAD_SYSTEM_REQUEST,
    CORE_LOAD_SYSTEM_SUCCESS,

    CORE_LOAD_ROLE_REQUEST,
    CORE_LOAD_ROLE_SUCCESS,

    CORE_LOAD_LOCAL_USERS_REQUEST,
    CORE_LOAD_LOCAL_USERS_SUCCESS,

    CORE_DELETE_LOCAL_USERS_REQUEST,
    CORE_DELETE_LOCAL_USERS_SUCCESS,

    CORE_LOAD_EXECUTIVE_ROOM_REQUEST,
    CORE_LOAD_EXECUTIVE_ROOM_SUCCESS,

    CORE_LOAD_USERFILTER_REQUEST,
    CORE_LOAD_USERFILTER_SUCCESS,

    // CORE_CHANGE_PASSWORD_REQUEST,
    // CORE_CHANGE_PASSWORD_SUCCESS,

    CORE_REQUEST_CHANGE_PASSWORD_REQUEST,
    CORE_REQUEST_CHANGE_PASSWORD_SUCCESS,

    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS

} from '../../types'

const initialState = []
export default {
    user: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_SYNC_REQUEST:
            case CORE_LOAD_SYNC_USER_REQUEST:
            case CORE_EDIT_SYNC_REQUEST:
            case CORE_DELETE_LOCAL_USERS_REQUEST:
                return initialState
            case CORE_CREATE_SYNC_SUCCESS:
                return action.payload
            case CORE_LOAD_SYNC_USER_SUCCESS:
            case CORE_EDIT_SYNC_SUCCESS:
            case CORE_DELETE_LOCAL_USERS_SUCCESS:
                if (typeof (action.payload) !== "undefined")
                    return action.payload
                else return [{}]

            default:
                return state
        }
    },
    system: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_SYSTEM_REQUEST:
                return initialState

            case CORE_LOAD_SYSTEM_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    localUsers: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_LOCAL_USERS_REQUEST:
            case CORE_LOAD_USERFILTER_REQUEST:
                return initialState

            case CORE_LOAD_LOCAL_USERS_SUCCESS:
            case CORE_LOAD_USERFILTER_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    role: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROLE_REQUEST:
                return initialState

            case CORE_LOAD_ROLE_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    executive: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_EXECUTIVE_ROOM_REQUEST:
                return initialState

            case CORE_LOAD_EXECUTIVE_ROOM_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    statusChangePassword: (state = initialState, action) => {
        switch (action.type) {
            case CORE_REQUEST_CHANGE_PASSWORD_REQUEST:
                return initialState
            case CORE_REQUEST_CHANGE_PASSWORD_SUCCESS:
                if (typeof (action.payload) !== "undefined")
                    return {
                        status: action.payload
                    }
                else return {}
            default:
                return state
        }
    },
    sendMailResetPassword: (state = initialState, action) => {
        switch (action.type) {
            case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST:
                return {}
            case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS:
                return {
                    status: action.payload
                }
            default:
                return {}
        }
    },
}



// WEBPACK FOOTER //
// ./src/features/users/reducer.js